var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9092 26.9289C13.9092 24.2569 15.6668 22.0909 18.4092 22.0909C21.1516 22.0909 22.9092 24.2569 22.9092 26.9289C22.9092 29.6008 18.7195 36 18.4092 36C18.0988 36 13.9092 29.6008 13.9092 26.9289Z",
    fill: "#2A8EFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0913 9.07115C22.0913 11.7431 20.3337 13.9091 17.5913 13.9091C14.8489 13.9091 13.0913 11.7431 13.0913 9.07115C13.0913 6.39922 17.281 0 17.5913 0C17.9017 0 22.0913 6.39922 22.0913 9.07115Z",
    fill: "#FF4F79"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9289 22.0908C24.2569 22.0908 22.0909 20.3332 22.0909 17.5908C22.0909 14.8484 24.2569 13.0908 26.9289 13.0908C29.6008 13.0908 36 17.2805 36 17.5908C36 17.9012 29.6008 22.0908 26.9289 22.0908Z",
    fill: "#37CC8F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07115 13.9092C11.7431 13.9092 13.9091 15.6668 13.9091 18.4092C13.9091 21.1516 11.7431 22.9092 9.07115 22.9092C6.39922 22.9092 4.98191e-08 18.7195 5.35091e-08 18.4092C5.7199e-08 18.0988 6.39922 13.9092 9.07115 13.9092Z",
    fill: "#EAC159"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29746 5.85475C9.17628 6.754 9.33031 8.05437 8.45907 8.94588C7.58782 9.83738 6.317 9.67977 5.43818 8.78051C4.55936 7.88125 3.78563 4.36555 3.88423 4.26466C3.98282 4.16377 7.41863 4.95549 8.29746 5.85475Z",
    fill: "#2A8EFA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29746 29.3274C9.17628 28.4281 9.33031 27.1278 8.45907 26.2363C7.58782 25.3447 6.317 25.5024 5.43818 26.4016C4.55936 27.3009 3.78563 30.8166 3.88423 30.9175C3.98282 31.0184 7.41863 30.2266 8.29746 29.3274Z",
    fill: "#37CC8F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8842 5.85475C26.0054 6.754 25.8513 8.05437 26.7226 8.94588C27.5938 9.83738 28.8646 9.67977 29.7435 8.78051C30.6223 7.88125 31.396 4.36555 31.2974 4.26466C31.1988 4.16377 27.763 4.95549 26.8842 5.85475Z",
    fill: "#EAC159"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8842 29.3274C26.0054 28.4281 25.8513 27.1278 26.7226 26.2363C27.5938 25.3447 28.8646 25.5024 29.7435 26.4016C30.6223 27.3009 31.396 30.8166 31.2974 30.9175C31.1988 31.0184 27.763 30.2266 26.8842 29.3274Z",
    fill: "#FF4F79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3fe946f70dd8bae97be364c7a2c439c3.svg";
export { ForwardRef as ReactComponent };